export const COOKIE_EXPIRES = [5, 'years'];
export const COOKIE_LINK = 'https://cookiesandyou.com/';
export const COOKIE_NAME = 'sizeid-cookie-consent';
